import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "resource-select ta-right" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 0 }

import MapElemInfoComment from './MapElemInfoComment.vue';
import {
  computed,
  onMounted,
  reactive,
  watch,
} from 'vue';
import type { MapElemInfo } from 'src/models';
import type { GeoItemMeta } from 'src/models/geoItem';
import type { NewMapElemData } from 'src/models/geoItemSearch';

interface MapElemInfoCommentElement extends MapElemInfo<NewMapElemData> {
  candidateImages: Blob[];
}

interface MapElemInfoNewState {
  selectedDataType: string;
  elemConv: MapElemInfoCommentElement | null;
}

// `:is="'map-elem-info-comment'"` の文字列ベース動的コンポーネント解決に必要
interface Props {
  elem: MapElemInfoCommentElement;
  visibleLayers: GeoItemMeta[];
  forceShowCancelButton?: boolean;
  createFailed: number;
}

export default /*@__PURE__*/_defineComponent({
  ...{ components: { MapElemInfoComment } },
  __name: 'MapElemInfoNew',
  props: {
    elem: {},
    visibleLayers: {},
    forceShowCancelButton: { type: Boolean, default: false },
    createFailed: {}
  },
  emits: ['create', 'cancel-edit'],
  setup(__props: any, { emit: __emit }) {


// withDefaultsでdefaultを与えても、TS上optional(?)でないとrequired:trueのままになるVueの仕様
// https://github.com/vuejs/core/blob/v3.5.35/packages/compiler-sfc/src/script/resolveType.ts (required: !e.optional)
// visibleLayers/createFailedは全呼び出し元が渡しているため必須のまま。forceShowCancelButtonはTop.vueの動的コンポーネント呼び出しが渡していないためoptionalのまま
const props = __props;
const emit = __emit;

const state = reactive<MapElemInfoNewState>({
  selectedDataType: '',
  elemConv: null,
});
const initDisplay = () => {
  const creatableLayers = props.visibleLayers.filter(e => e.isCreatable);
  state.selectedDataType = creatableLayers.length > 0 ? creatableLayers[0].name : '';
  if (props.elem) {
    state.elemConv = {
      dataName: state.selectedDataType,
      data: props.elem.data,
      candidateImages: props.elem.candidateImages,
    };
  }
};

onMounted(initDisplay);

watch(() => props.elem, initDisplay);
watch(() => props.visibleLayers, () => {
  const arr = props.visibleLayers.map(e => e.name);
  if (!arr.includes(state.selectedDataType)) {
    initDisplay();
  }
});

const currentElemInfoComponent = computed(() => {
  if (!state.elemConv) return '';

  return 'map-elem-info-' + state.elemConv.dataName;
});
const selectableDataTypes = computed(() => {
  return props.visibleLayers.filter(e => e.isCreatable).map(e => {
    return { name: e.name, dispName: e.dispName };
  });
});

const onChildComponentUpdate = (obj: MapElemInfoCommentElement) => {
  // イベント種別を変換して投げ直す
  emit('create', obj);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ib vm lbl" }, "レイヤーデータ:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.selectedDataType) = $event)),
        class: "custom-select"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableDataTypes.value, (e) => {
          return (_openBlock(), _createElementBlock("option", {
            key: e.name,
            value: e.name
          }, _toDisplayString(e.dispName), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, state.selectedDataType]
      ])
    ], 512), [
      [_vShow, selectableDataTypes.value.length > 1]
    ]),
    (state.elemConv && state.elemConv.dataName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(currentElemInfoComponent.value), {
            elem: state.elemConv,
            "is-create-single-new-element": true,
            "force-show-cancel-button": __props.forceShowCancelButton,
            "create-failed": __props.createFailed,
            onUpdate: onChildComponentUpdate,
            onCancelEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel-edit')))
          }, null, 40, ["elem", "force-show-cancel-button", "create-failed"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})